import React, { Suspense } from 'react';
import { Loader, InvestmentSummaryTitle } from '@dekafvv/sharedfrontend';
import { Outlet } from '@hydrogen/elements.core.router';
import { Wrapper } from 'components/Layout/Wrapper';

import { InvestmentDetailContent } from 'components/Layout/InvestmentDetailContent';

const InvestmentOverview = React.lazy(() => import('pages/InvestmentOverview/InvestmentOverview'));

export const investmentDetail = {
    Component: InvestmentDetailContent,
    url: 'investments/:investmentId/',
    props: {
        title: <InvestmentSummaryTitle />,
        children: <Outlet />,
    },
    children: [
        {
            url: '',
            Component: Wrapper,
            props: {
                children: <Suspense fallback={<Loader />}><InvestmentOverview /></Suspense>,
            },
        },
    ],
};
